// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"333":"tarot","461":"mcd","508":"tools","757":"not-found","769":"world"}[chunkId] + "." + {"333":"be7b50a6","461":"1fc1031d","508":"a12a2691","757":"c3d011aa","769":"6b743e94"}[chunkId] + ".css";
};